import { render, staticRenderFns } from "./DouSearch.vue?vue&type=template&id=3b005bde&scoped=true"
import script from "./DouSearch.vue?vue&type=script&lang=js"
export * from "./DouSearch.vue?vue&type=script&lang=js"
import style0 from "./DouSearch.vue?vue&type=style&index=0&id=3b005bde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b005bde",
  null
  
)

export default component.exports